import '../scss/main.scss';

import * as animazioni from './animazioni-gsap';
import * as menu from './menu';
import { sectionNewsSwiper, marqueeSwiper } from './swiper-functions';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

/** LENIS INIZIALIZZAZIONE */
const lenis = new Lenis();

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);


/** ANIMAZIONI GSAP */
animazioni.animY();
animazioni.zoomOut();
animazioni.animazioneHeroHome();
animazioni.animazioneSezioneMenu();
animazioni.animazioneBanner("#photo-gastronomia");
animazioni.animazioneBanner("#photo-ristorante");
animazioni.animazioneBanner("#photo-chi-siamo");

/** MENU MOBILE */
menu.menuMobile();

/** SWIPER NEWS SECTION */
sectionNewsSwiper();
marqueeSwiper();